<template>
  <TextField v-bind="$props" dir="ltr">
    <template #append-inner>
      <CopyBtn :value msg="link_copied" />
    </template>
  </TextField>
</template>

<script setup lang="ts">
defineProps<{
  value: string
}>();
</script>